import React from 'react';
import { FormattedMessage } from 'react-intl';

export enum LensesExperience {
  newWear = 'NEWWEAR',
  lessThanOneYear = 'LESSTHANONEYEAR',
  moreThanOneYear = 'MORETHANONEYEAR',
  dropOut = 'DROPOUT',
}

export const experience = [
  {
    label: <FormattedMessage id="lenses.wearingExperience.newwear"/>,
    value: LensesExperience.newWear,
  },
  {
    label: <FormattedMessage id="lenses.wearingExperience.lessThanYear" />,
    value: LensesExperience.lessThanOneYear,
  },
  {
    label: <FormattedMessage id="lenses.wearingExperience.moreThanYear" />,
    value: LensesExperience.moreThanOneYear,
  },
  {
    label: <FormattedMessage id="lenses.wearingExperience.dropout" />,
    value: LensesExperience.dropOut,
  },
];

export const DEPENDENTS_LIMIT = 5;
